import { useEffect } from "react";
import "./Contact.css";

export default function Contact() {

    useEffect(() => {

    }, []);

    return (
        <div class='home-container'> 
            <a href="https://dot.cards/marcthecs" target="_blank" rel="noopener noreferrer">
                <img src="dotprofile.png" alt="Marc's Dot Card" height="800" width="400" />
            </a>
        </div>
    );
}